/* eslint-disable max-classes-per-file */
import { Modal, ModalController } from '~/scripts/services/modal/modal';
import template from './filter-menu.html';
import './filter-menu.scss';

/**
 * @typedef {Object} Entry
 * @property {string} name
 * @property {boolean} checked
 */

/**
 * @typedef {Object} FilterMenuModalOptions
 * @property {Array<*>} entries
 */

class Controller extends ModalController {
	/* @ngInject */
	constructor(options, $uibModalInstance) {
		super(options, $uibModalInstance);

		this.search = '';
		this.entries = this.options.entries;
	}

	selectAll() {
		for (const entry of this.entries) {
			entry.checked = true;
		}
	}

	deselectAll() {
		for (const entry of this.entries) {
			entry.checked = false;
		}
	}

	onSearchChange() {
		this.entries = this.options.entries.filter(entry => {
			if (this.search === '') {
				return true;
			}
			if (!entry.name) {
				return false;
			}
			return entry.name.toLowerCase().includes(this.search.toLowerCase());
		});
	}
}

export default class FilterMenuModal extends Modal {
	/**
	 * @param {FilterMenuModalOptions} options
	 * @returns {Promise<Array<Entry>>} return
	 */
	// @ts-ignore
	open(options) {
		return super.open({
			template,
			controller: Controller,
			windowTopClass: 'filter-menu',
		}, options);
	}
}
